import Link from 'next/link';
import { NodeWithSvg } from '../../../NodeWithSvg';
import { useLink } from '../../link.hook';
import { ILinkA } from './linkA.models';
import * as S from './linkA.style';

export const A: React.FC<ILinkA> = ({
  as,
  children,
  disableAppMobileOpenInBrowser,
  disabled,
  href: _href,
  locale,
  onClick: _onClick,
  onMouseEnter: _onMouseEnter,
  onMouseLeave: _onMouseLeave,
  onTouchStart,
  prefetch,
  replace,
  scroll,
  shallow,
  size: _size,
  svg,
  svgPosition,
  variant = 'regular',
  ...rest
}) => {
  const { color, height, href, onClick, onMouseEnter, onMouseLeave, size } =
    useLink<HTMLAnchorElement>({
      _href,
      _onClick,
      _onMouseEnter,
      _onMouseLeave,
      _size,
      disableAppMobileOpenInBrowser,
      disabled,
      variant,
    });

  const anchorTag = (
    <S.A
      {...rest}
      disabled={!href || disabled}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onTouchStart={onTouchStart}
      size={size}
      variant={variant}
    >
      <NodeWithSvg color={color} height={height} svg={svg} svgPosition={svgPosition}>
        {children}
      </NodeWithSvg>
    </S.A>
  );

  if (!href) {
    return anchorTag;
  }

  return (
    <Link
      as={as}
      href={href}
      locale={locale}
      passHref={!disabled}
      prefetch={prefetch}
      replace={replace}
      scroll={scroll}
      shallow={shallow}
      legacyBehavior
    >
      {anchorTag}
    </Link>
  );
};

